<template>
    <div>
        <issues-desktop v-if="!isMobile"/>
        <issues-mobile v-if="isMobile"/>
    </div>

</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import IssuesDesktop from "./IssuesDesktop";
    import IssuesMobile from "./IssuesMobile";

    export default {
        name: "Issues",
        components: {IssuesMobile, IssuesDesktop},
        computed: {
            ...mapGetters([
                "isMobile"
            ]),
        },

    }
</script>

<style scoped>

</style>
